import React from 'react';
import { Menu } from 'antd';
import {Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import './MenuBar.css';

import SearchBar from '../elements/SearchBar';
import NavLink from './NavLink';

const MenuBar = ({ closeDrawer, className = 'only-desktop', mode = 'horizontal', locale, menuList, history, ...props }) => (
  <Menu className={className} mode={mode} {...props} dispatch='' >
    <Menu.Item onClick={closeDrawer} key="logo" className="only-mobile" style={{ height: 70, display: 'flex', backgroundColor: '#FFF' }}>
      <Link to="/">
        <img alt='web-khoa-ou-icon' src="/assets/images/ou-logo.png" style={{ height: '70px', width: 'auto', objectFit: 'contain' }} />
      </Link>
    </Menu.Item>
    {menuList.map(menuItem => {
      const title = menuItem.title.find(i => i.lang === locale) || "";
      if (title !== "") {
      const subItems = menuItem.items;
      subItems.sort((a,b) => {return (b.position - a.position)});      
      return (
        <Menu.SubMenu key={menuItem._id} title={title.value} onTitleClick={() => history.push(title.url)} onClick={closeDrawer}>
          {subItems.map(item => {
            const itemTitle = item.title.find(i => i.lang === locale) || "";
            if (itemTitle !== "") {
            return (
              <Menu.Item key={item._id} onClick={closeDrawer}>
                <NavLink to={itemTitle.url}>
                  {itemTitle.value}
                </NavLink>
              </Menu.Item>
            )};
          })}
        </Menu.SubMenu>
      )};
    })}
    {/* <Menu.Item onClick={closeDrawer} className="only-mobile" key="dang-nhap">
      <Link to="/login">Đăng nhập</Link>
    </Menu.Item> */}
    <Menu.Item key="tk" style={{ borderBottom: 0, float: 'right' }}>
      <SearchBar />
    </Menu.Item>
  </Menu>
);

export default connect(state => ({
  locale: state.intl.locale,
  menuList: state.app.menuList,
}))(withRouter(MenuBar));



// WEBPACK FOOTER //
// ./src/components/layouts/MenuBar.js